import { render } from "./OrderAction.vue?vue&type=template&id=06190c56&scoped=true"
import script from "./OrderAction.vue?vue&type=script&lang=js"
export * from "./OrderAction.vue?vue&type=script&lang=js"

import "./OrderAction.vue?vue&type=style&index=0&id=06190c56&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06190c56"]])

export default __exports__